import type React from 'react';

import { type CampaignInfoType, CAMPAIGN_INFO_TYPES } from '../../../../../../types/campaign.types';
import NextWinCurrency from './NextWinCurrency';

export interface CampaignInfoSuffixProps {
  suffix?: string;
  attributes: Record<string, string | undefined>;
}

type CampaignInfoSuffixComponent = React.FC<CampaignInfoSuffixProps>;

const SUFFIX_COMPONENTS: Partial<Record<CampaignInfoType, CampaignInfoSuffixComponent>> = {
  [CAMPAIGN_INFO_TYPES.NEXT_WIN]: NextWinCurrency as CampaignInfoSuffixComponent,
};

export const getCampaignInfoSuffix = (type: CampaignInfoType): CampaignInfoSuffixComponent | undefined =>
  SUFFIX_COMPONENTS[type];
